// Sistema de cache para dados da API
type CacheItem<T> = {
  data: T
  timestamp: number
  expiresIn: number // tempo em ms
}

class ApiCache {
  private cache: Record<string, CacheItem<any>> = {}
  private readonly DEFAULT_EXPIRY = 5 * 60 * 1000 // 5 minutos

  // Obter dados do cache
  get<T>(key: string): T | null {
    const item = this.cache[key]

    // Se não existir no cache ou estiver expirado
    if (!item || Date.now() > item.timestamp + item.expiresIn) {
      if (item) {
        // Remover item expirado
        delete this.cache[key]
      }
      return null
    }

    return item.data
  }

  // Armazenar dados no cache
  set<T>(key: string, data: T, expiresIn: number = this.DEFAULT_EXPIRY): void {
    this.cache[key] = {
      data,
      timestamp: Date.now(),
      expiresIn,
    }
  }

  // Verificar se existe no cache e não está expirado
  has(key: string): boolean {
    const item = this.cache[key]
    return !!item && Date.now() <= item.timestamp + item.expiresIn
  }

  // Limpar cache
  clear(): void {
    this.cache = {}
  }

  // Remover item específico
  remove(key: string): void {
    delete this.cache[key]
  }
}

// Exportar instância singleton
export const apiCache = new ApiCache()
